import { observer } from "mobx-react";
import { useEffect } from "react";

import { Popup } from "components/Popup/Popup";
import Button from "components/UI/Button/Button";
import { ButtonWithIcon } from "components/UI/ButtonWithIcon/ButtonWithIcon";
import InfoPoint from "components/UI/InfoPoint/InfoPoint";

import AppStore from "AppStore";
import popupBoxStore from "PopupBox/PopupBoxStore";
import popupStore from "components/Popup/PopupStore";

import list from "assets/images/botIcon/list.svg";
import time from "assets/images/botIcon/time.svg";
import clock from "assets/images/botIcon/clock.svg";
import telegram from "assets/images/botIcon/tg-logo.svg";
import number2 from "assets/images/botIcon/number-2.svg";

import "./BotModal.scss";

export const BotModal = observer(() => {

  const infoPointsTop = [
    { icon: list, text: "Отправим отчеты по выбранным типам заданий", },
    { icon: time, text: "Сообщим о времени на проверку", subtext: AppStore.telegramId === null && AppStore.showFirstProjectBotNotification ? <><br /><b>Внимание!</b> Модерация отчетов <span>обязательна</span></>  : null },
    { icon: clock, text: "Предупредим об автопринятии за 24 ч., чтобы вы точно успели проверить отчет", },
  ];

  const infoPointsBottom = [
    { icon: number2, text: "Перейдите в Telegram-бот и вставьте код. Следуйте инструкциям бота", },
  ];

  const handleCopyCode = (code) => {
    navigator.clipboard.writeText(code);
    popupBoxStore.showInfo("Код скопирован");
  }

  const handleClose = () => {
    popupStore.close();

    if (AppStore.showFirstProjectBotNotification) {      
      setTimeout(() => {
        AppStore.setHasSeenFirstProjectBotNotification();
        AppStore.setShowFirstProjectBotNotification(false);
      }, 300);
    }
  };

  useEffect(() => {
    const originalClose = popupStore.close;
    
    popupStore.close = () => {
      originalClose.call(popupStore);
    
      if (AppStore.showFirstProjectBotNotification) {
        setTimeout(() => {
          AppStore.setHasSeenFirstProjectBotNotification();
          AppStore.setShowFirstProjectBotNotification(false);
        }, 300);
      }
    };
    
    return () => {
      popupStore.close = originalClose;
    };
  }, []);

  return (
    <Popup modalType={`bot-modal`} title={AppStore.telegramId === null && AppStore.showFirstProjectBotNotification ? <p>Подключите уведомления, <br /> чтобы не потерять деньги</p> : "Уведомления в Telegram"}>
      <div className="bot-modal__container">
        <div className="bot-modal__info_points-top">
          {infoPointsTop.map(({ icon, text, subtext }, index) => <InfoPoint key={index} icon={icon} text={text} span={subtext} />)}
        </div>

        {AppStore.telegramId === null && AppStore.showFirstProjectBotNotification &&
          <div className="bot-modal__bot-notification">
            <p className="bot-modal__bot-notification-title">Зачем мне уведомления в Telegram?</p>
            <p className="bot-modal__bot-notification-text">Вы вовремя проверите отчет и <span>не потеряете деньги</span> из-за недобросовестного исполнителя или по истечении 78 ч. на проверку!</p>
          </div>
        }

        {AppStore.telegramId === null && 
          <div className="bot-modal__info_points">
            <p className="bot-modal__info_points-title">Как подключить?</p>
            <div className="bot-modal__info_points-bottom">
              <div className="bot-modal__info_points-item">
                <div className="bot-modal__info_points-item-icon" />
                <p className="bot-modal__info_points-item-text">Скопируйте код:</p>
                <div className="bot-modal__info_points-item-code">
                  <p className="bot-modal__info_points-item-code-text">{AppStore.OTP}</p>
                  <div className="bot-modal__info_points-item-code-icon" onClick={() => handleCopyCode(AppStore.OTP)} />
                </div>
              </div>
              {infoPointsBottom.map(({ icon, text }, index) => <InfoPoint key={index} icon={icon} text={text} />)}
            </div>
          </div>
        }

        <div className="bot-modal__buttons">
          <ButtonWithIcon
            className="bot-modal__button-bot"
            title="Перейти в Telegram-бота"
            icon={telegram}
            ariaLabel="Кнопка бота-уведомлений"
            to={(process.env.REACT_APP_BOT_ADDRESS ?? 'https://t.me/BoostclickBot') + (AppStore.telegramId ? '' : `?start=${AppStore.OTP}`)}
            onClick={() => {}}
          />

          {AppStore.telegramId === null && AppStore.showFirstProjectBotNotification &&
            <Button
              className="bot-modal__button-later"
              title="У меня все под контролем"
              ariaLabel="Настроить позже"
              onClick={handleClose}
            />
          }
        </div>
      </div>
    </Popup>
  );
});

export default BotModal;
